import * as ReactDOMClient from 'react-dom/client';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Help from '../app/screens/Help';
var rootElement = document.getElementById('help');
var root = ReactDOMClient.createRoot(rootElement);
root.render(<HashRouter>
    <Routes>
      <Route path="/" element={<Help />}/>
    </Routes>
  </HashRouter>);
